import React from "react";

const Image = ({ src, ...props }) => {
  let nextImagePath = process.env.isNext ? "next/image" : "/";
  if (process.env.isNext) {
    try {
      //@ts-ignore
      return React.createElement(require.resolve(nextImagePath).default, {
        src: typeof src === "string" ? src : src.src,
        ...props,
      });
    } catch {
      return React.createElement("img", { src, ...props });
    }
  } else {
    return React.createElement("img", { src, ...props });
  }
};

export default React.memo(Image);
